/* eslint-disable no-param-reassign */
import axios from 'axios';
import cacheAxios from '../../util/cacheAxios';

const legisAxios = axios.create();
const cache = new Map();
cacheAxios(legisAxios, cache);
legisAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims#/legislation';
      }, 500);
    }
  });

export default {
  state: {
    continents: [],
    groups: [],
    socialSecurityGroups: [],
    legislation: {},
    socialSecurity: {},
  },
  mutations: {
    setCountryLegislation(state, legis) {
      state.legislation = legis;
    },
    setCountrySocialSecurity(state, ss) {
      const socialSec = {};
      ss.forEach((s) => { socialSec[s.socialSecurityType] = s.topics; });
      state.socialSecurity = socialSec;
    },
    setLegislationContinents(state, continents) {
      state.continents = continents;
    },
    setLegislationGroups(state, groups) {
      state.groups = groups.map(g => ({
        ...g,
        name: g.group,
      }));
    },
    setSocialSecurityGroups(state, groups) {
      state.socialSecurityGroups = groups.map(g => ({
        type: 'socialSecurity',
        group: g.group,
        name: `Social Security - ${g.group}`,
        items: g.items.map(it => ({ key: it, value: it })),
      }));
    },
  },
  actions: {
    getLegislationCountries({ commit }) {
      legisAxios.get('/aims/api/legislation/countries').then((res) => {
        if (res && res.data) {
          commit('setLegislationContinents', res.data);
        }
      });
    },
    getLegislationGroups({ commit }) {
      legisAxios.get('/aims/api/legislation/groups').then((res) => {
        if (res && res.data) {
          commit('setLegislationGroups', res.data);
        }
      });
    },
    getSocialSecurityGroups({ commit }) {
      legisAxios.get('/aims/api/legislation/socialsecuritygroups').then((res) => {
        if (res && res.data) {
          commit('setSocialSecurityGroups', res.data);
        }
      });
    },
    getCountryLegislation({ commit }, countryCode) {
      legisAxios.get(`/aims/api/legislation/legislation/${countryCode}`, {
        cache: true,
        cacheKey: `/aims/api/legislation/legislation/${countryCode}`,
      }).then((res) => {
        if (res && res.data) {
          commit('setCountryLegislation', res.data);
        } else {
          commit('setCountryLegislation', {});
        }
      });
    },
    getCountrySocialSecurity({ state, commit }, country) {
      const cty = state.continents.find(c => c.continent === country[0])
        .regions.find(r => r.region === country[1])
        .countries.find(c => c.countryCode === country[2]);
      legisAxios.get(`/aims/api/legislation/socialsecurity/${cty.countryName}`, {
        cache: true,
        cacheKey: `/aims/api/legislation/socialsecurity/${cty.countryName}`,
      }).then((res) => {
        if (res && res.data) {
          commit('setCountrySocialSecurity', res.data);
        } else {
          commit('setCountrySocialSecurity', []);
        }
      });
    },
  },
  getters: {
    legislationCountryTree(state) {
      return state.continents.map(con => ({
        label: con.continent,
        value: con.continent,
        children: con.regions.map(reg => ({
          label: reg.region,
          value: reg.region,
          children: reg.countries.map(c => ({
            label: c.countryName,
            value: c.countryCode,
          })),
        })),
      }));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/legislationModule.js